import { useCallback, useState, useEffect, useRef } from 'react'
import ChatBoat from '../../assets/images/wa_chat_bg.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell, faBullhorn, faKey, faEye, faPhone, faLink, faComment, faCopy, faCode } from '@fortawesome/free-solid-svg-icons';
import Templatename from './templatename/templatename';
import Templatebody from './templatebody/templatebody';
import { useFormik } from 'formik';
import * as Yup from "yup";
import { PrimaryColor } from '../../../reusecomponent/color';
import Templateheader from './templateheader/templateheader';
import Templatefooter from './templatefooter/templatefooter';
import '../../../index.css';
import domain from '../../../reusecomponent/domain';
import { getToken } from '../../function/token';
import { SuccessToastContainer, ErrorToastContainer } from '../../function/CustomFunction';
import { useParams, useNavigate } from 'react-router-dom';

function Createtemplate() {
  // Get templateId from URL if it exists
  const { templateId } = useParams();
  const navigate = useNavigate();
  const isEditMode = !!templateId;
  
  // Create separate variable states for header and body
  const [headerVariable, setHeaderVariable] = useState({data: [], count: 0});
  const [bodyVariable, setBodyVariable] = useState({data: [], count: 0});
  const [categoryerror, setcategoryerror] = useState('');
  const [advancedOptions, setAdvancedOptions] = useState(false);
  const [headerPreviewUrl, setHeaderPreviewUrl] = useState(null);
  const [currentTime, setCurrentTime] = useState('');
  const [mediaError, setMediaError] = useState('');
  const [technicalPreview, setTechnicalPreview] = useState(false);
  const [loading, setLoading] = useState(isEditMode);
  const [codeDeliveryMethod, setCodeDeliveryMethod] = useState('COPY_CODE');
  
  // 1. Create a ref for resetForm
  const resetFormRef = useRef();

  // 2. Formik initialization
  const initialvalues = {
    templatename: '',
    templatelanguages: '',
    bodymessage: '',
    bodyprintmessage: '',
    templatecategory: 3,
    footermessage: '',
    buttons: [],
    // Separate example values for header and body
    headerExampleValues: {},
    bodyExampleValues: {},
    headerType: 'NONE',
    headerText: '',
    headerMedia: null,
    buttonType: 'QUICK_REPLY' // can be 'QUICK_REPLY', 'URL', 'PHONE_NUMBER', 'copy_code'
  };

  const [formInitialValues, setFormInitialValues] = useState(initialvalues);

  const validationSchema = Yup.object({
    templatename: Yup.string().required("Template name is required"),
    templatelanguages: Yup.string().required("Please select a language"),
    bodymessage: Yup.string().required("Please Write Minimum 10 word"),
  });

  const formik = useFormik({
    initialValues: formInitialValues,
    validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      // Check permission before submission
      // const requiredPermission = isEditMode ? PERMISSIONS.TEMPLATES_UPDATE : PERMISSIONS.TEMPLATES_CREATE;
      // if (!hasPermission(requiredPermission)) {
      //   ErrorToastContainer(`You don't have permission to ${isEditMode ? 'update' : 'create'} templates`);
      //   setSubmitting(false);
      //   return;
      // }
      
      setSubmitting(false);
      let templateData = generateTemplateData();
      console.log("Generated template data for submission:", templateData);
      
      // Final check for authentication templates to ensure no text field in BODY
      if (values.templatecategory === 2) {
        const bodyComponent = templateData.find(c => c.type === 'BODY');
        if (bodyComponent && bodyComponent.text) {
          delete bodyComponent.text;
        }
      }

      const body = new FormData();
      // ...
    },
    validateOnChange: false,
    validateOnBlur: true, 
    enableReinitialize: true, // now true
  });

  // 3. Always keep the latest resetForm in the ref
  useEffect(() => {
    resetFormRef.current = formik.resetForm;
  }, [formik.resetForm]);

  // 4. UseEffect for fetching template data
  useEffect(() => {
    if (isEditMode) {
      const fetchTemplateData = async () => {
        try {
          setLoading(true);
          const access_token = getToken();
          if (!access_token) {
            ErrorToastContainer("Authentication error. Please log in again.");
            navigate('/');
            return;
          }
          const myHeaders = new Headers();
          myHeaders.append("Authorization", `Bearer ${access_token}`);
          const requestOptions = {
            method: "GET",
            headers: myHeaders,
            redirect: "follow"
          };
          const response = await fetch(`${domain()}/edit/${templateId}`, requestOptions);
          const result = await response.json();
          if (result.status) {
            const templateData = result.data;
            let componentsArray = [];
            try {
              if (Array.isArray(templateData.components)) {
                componentsArray = templateData.components;
              } else if (typeof templateData.components === 'string' && templateData.components.trim() !== '') {
                componentsArray = JSON.parse(templateData.components);
              }
            } catch (e) {
              componentsArray = [];
            }
            if (!componentsArray.length) {
              ErrorToastContainer("Template configuration missing or invalid.");
              navigate('/client-area/whatsapp/manage-template');
              return;
            }
            // Build new values object for Formik
            const newValues = {
              templatename: templateData.template_name || '',
              templatelanguages: templateData.language || '',
              templatecategory: mapCategoryToNumber(templateData.category),
              bodymessage: '',
              bodyprintmessage: '',
              footermessage: '',
              buttons: [],
              headerExampleValues: {},
              bodyExampleValues: {},
              headerType: 'NONE',
              headerText: '',
              headerMedia: null,
              buttonType: 'QUICK_REPLY'
            };
            componentsArray.forEach(component => {
              if (component.type === 'HEADER') {
                newValues.headerType = component.format || 'NONE';
                if (component.format === 'TEXT') {
                  newValues.headerText = component.text || '';
                  if (component.example && component.example.header_text) {
                    const exampleValues = {};
                    const headerVars = (component.text || '').match(/\{\{(\d+)\}\}/g) || [];
                    const varNumbers = headerVars.map(v => parseInt(v.replace(/[{}]/g, '')));
                    varNumbers.forEach((num, index) => {
                      exampleValues[num] = component.example.header_text[index] || '';
                    });
                    newValues.headerExampleValues = exampleValues;
                  }
                } else if (component.format === 'IMAGE') {
                  if (component.example && component.example.header_handle && component.example.header_handle[0]) {
                    newValues.headerMedia = { url: component.example.header_handle[0] };
                  } else {
                    newValues.headerMedia = null;
                  }
                }
              } else if (component.type === 'BODY') {
                newValues.bodymessage = component.text || '';
                if (component.example && component.example.body_text && component.example.body_text[0]) {
                  const exampleValues = {};
                  const bodyVars = (component.text || '').match(/\{\{(\d+)\}\}/g) || [];
                  const varNumbers = bodyVars.map(v => parseInt(v.replace(/[{}]/g, '')));
                  varNumbers.forEach((num, index) => {
                    exampleValues[num] = component.example.body_text[0][index] || '';
                  });
                  newValues.bodyExampleValues = exampleValues;
                }
              } else if (component.type === 'FOOTER') {
                newValues.footermessage = component.text || '';
              } else if (component.type === 'BUTTONS') {
                if (component.buttons && Array.isArray(component.buttons)) {
                  newValues.buttons = component.buttons.map(btn => ({
                    type: btn.type === 'OTP' ? 'COPY_CODE' : (btn.type || 'QUICK_REPLY'),
                    text: btn.text || '',
                    url: btn.url || '',
                    phone_number: btn.phone_number || '',
                    value: btn.value || ''
                  }));
                }
              }
            });
            if (typeof newValues.templatelanguages !== 'string') {
              newValues.templatelanguages = String(newValues.templatelanguages || '');
            }
            if (!newValues.bodymessage) newValues.bodymessage = '';
            if (!newValues.footermessage) newValues.footermessage = '';
            if (!newValues.headerType) newValues.headerType = 'NONE';
            if (!newValues.headerText) newValues.headerText = '';
            if (!newValues.headerExampleValues) newValues.headerExampleValues = {};
            if (!newValues.bodyExampleValues) newValues.bodyExampleValues = {};
            if (!newValues.buttons) newValues.buttons = [];
            if (!newValues.buttonType) newValues.buttonType = 'QUICK_REPLY';
            if (!newValues.headerMedia) newValues.headerMedia = null;
            if (!newValues.bodyprintmessage) newValues.bodyprintmessage = '';
            
            // Check if this is an authentication template - prevent editing
            if (newValues.templatecategory === 2) {
              ErrorToastContainer("Authentication templates cannot be edited. Please create a new template instead.");
              navigate('/client-area/whatsapp/manage-template');
              return;
            }
            
            // Populate variable state from newValues
            const headerVars = (newValues.headerText || '').match(/\{\{(\d+)\}\}/g) || [];
            setHeaderVariable({ data: headerVars.map(v => parseInt(v.replace(/[{}]/g, ''))), count: headerVars.length });

            const bodyVars = (newValues.bodymessage || '').match(/\{\{(\d+)\}\}/g) || [];
            setBodyVariable({ data: bodyVars.map(v => parseInt(v.replace(/[{}]/g, ''))), count: bodyVars.length });

            setFormInitialValues(newValues);
            SuccessToastContainer("Template loaded successfully");
          } else {
            ErrorToastContainer(result.message || "Failed to load template");
            navigate('/client-area/whatsapp/manage-template');
          }
        } catch (error) {

          ErrorToastContainer("Error loading template. Please try again later.");
          navigate('/client-area/whatsapp/manage-template');
        } finally {
          setLoading(false);
        }
      };
      fetchTemplateData();
    } else {
      // Not in edit mode, reset to initial blank values
      setFormInitialValues(initialvalues);
    }
  }, [templateId, isEditMode]);

  // Destructure Formik helpers for use in the rest of the component
  const {values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue, resetForm} = formik;

  // Update current time for the preview
  useEffect(() => {
    const now = new Date();
    setCurrentTime(now.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'}));
    
    // Update time every minute
    const timer = setInterval(() => {
      const now = new Date();
      setCurrentTime(now.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'}));
    }, 60000);
    
    return () => clearInterval(timer);
  }, []);
  
  // Cleanup preview URLs on unmount
  useEffect(() => {
    return () => {
      if (headerPreviewUrl) {
        URL.revokeObjectURL(headerPreviewUrl);
      }
    };
  }, [headerPreviewUrl]);

  const CateGory = useCallback((c) => {
    // Reset the form to initial values, but set the new category
    resetForm({
      values: {
        ...initialvalues,
        templatecategory: c
      }
    });
    setcategoryerror("");
    setHeaderVariable({data: [], count: 0});
    setBodyVariable({data: [], count: 0});
    setHeaderPreviewUrl(null);
    setMediaError('');
    setAdvancedOptions(false);
    setTechnicalPreview(false);
  }, [resetForm]);

  // Function to toggle advanced options
  const toggleAdvancedOptions = () => {
    setAdvancedOptions(!advancedOptions);
  };
  
  // Function to toggle technical preview
  const toggleTechnicalPreview = () => {
    setTechnicalPreview(!technicalPreview);
  };

  // Function to render the preview based on the current values
  const renderPreview = () => {
    // Replace variables with example values if they exist
    let previewText = values.bodymessage || '';
    
    // Replace variables with example values
    if (values.bodyExampleValues && Object.keys(values.bodyExampleValues).length > 0) {
      Object.keys(values.bodyExampleValues).forEach(key => {
        const variablePattern = new RegExp(`\\{\\{${key}\\}\\}`, 'g');
        if (values.bodyExampleValues[key] !== undefined && values.bodyExampleValues[key] !== '') {
          previewText = previewText.replace(variablePattern, 
            `<span class="text-primary">${values.bodyExampleValues[key]}</span>`);
        } else {
          // Keep the placeholder in the preview if the value is empty
          previewText = previewText.replace(variablePattern, 
            `<span style="opacity: 0.6; font-style: italic;">{{${key}}}</span>`);
        }
      });
    }
    
    // Apply formatting
    previewText = previewText
      .replace(/\*(.*?)\*/g, "<strong>$1</strong>")
      .replace(/_(.*?)_/g, "<em>$1</em>")
      .replace(/~(.*?)~/g, "<del>$1</del>")
      .replace(/```(.*?)```/g, "<code>$1</code>")
      .replace(/•\s(.*?)(?=(\n|$))/g, "<div class='bullet-item'>• $1</div>")
      .replace(/(\d+)\.\s(.*?)(?=(\n|$))/g, "<div class='number-item'>$1. $2</div>");
    
    // Replace newlines with <br>
    previewText = previewText.replace(/\n/g, "<br>");
    
    return previewText;
  };

  // Function to replace variables in header text for the preview
  const renderHeaderPreview = () => {
    if (!values.headerText) return '';
    
    let previewText = values.headerText;
    
    // Replace variables with example values
    if (values.headerExampleValues && Object.keys(values.headerExampleValues).length > 0) {
      Object.keys(values.headerExampleValues).forEach(key => {
        const variablePattern = new RegExp(`\\{\\{${key}\\}\\}`, 'g');
        if (values.headerExampleValues[key] !== undefined && values.headerExampleValues[key] !== '') {
          previewText = previewText.replace(variablePattern, 
            `<span class="variable-highlight">${values.headerExampleValues[key]}</span>`);
        } else {
          // Keep the placeholder in the preview if the value is empty
          previewText = previewText.replace(variablePattern, 
            `<span style="opacity: 0.6; font-style: italic;">{{${key}}}</span>`);
        }
      });
    }
    
    return previewText;
  };

  // Function to handle header file upload
  const handleHeaderFileChange = (file, type, uploadedFileData) => {
    setMediaError('');
    
    console.log("=== handleHeaderFileChange DEBUG ===");
    console.log("file:", file);
    console.log("type:", type);
    console.log("uploadedFileData:", uploadedFileData);
    console.log("uploadedFileData type:", typeof uploadedFileData);
    console.log("uploadedFileData stringified:", JSON.stringify(uploadedFileData));
    
    if (!file) {
      setHeaderPreviewUrl(null);
      setFieldValue('headerMedia', null);
      setFieldValue('headerType', type);
      return;
    }
    
    // Process file based on type
    if (type === 'IMAGE') {
      const imageUrl = URL.createObjectURL(file);
      setHeaderPreviewUrl(imageUrl);
      const mediaData = {
        file: file,
        uploadedData: { data: uploadedFileData } // Wrap the token data in an object
      };
      console.log("Setting headerMedia for IMAGE:", mediaData);
      console.log("mediaData.uploadedData.data:", mediaData.uploadedData.data);
      setFieldValue('headerMedia', mediaData);
      setFieldValue('headerType', type);
      
    } else if (type === 'VIDEO') {
      setHeaderPreviewUrl(null); // No preview for videos in the main preview
      const mediaData = {
        file: file,
        uploadedData: { data: uploadedFileData } // Wrap the token data in an object
      };
      console.log("Setting headerMedia for VIDEO:", mediaData);
      setFieldValue('headerMedia', mediaData);
      setFieldValue('headerType', type);
      
    } else if (type === 'DOCUMENT') {
      setHeaderPreviewUrl(null); // No preview for documents in the main preview
      const mediaData = {
        file: file,
        uploadedData: { data: uploadedFileData } // Wrap the token data in an object
      };
      console.log("Setting headerMedia for DOCUMENT:", mediaData);
      setFieldValue('headerMedia', mediaData);
      setFieldValue('headerType', type);
    }
  };

  // Function to handle header text change
  const handleHeaderTextChange = (text) => {
    setFieldValue('headerText', text);
    setFieldValue('headerType', 'TEXT');
  };

  // Function to get button icon based on type
  const getButtonIcon = (buttonType) => {
    switch(buttonType) {
      case 'URL':
        return faLink;
      case 'PHONE_NUMBER':
        return faPhone;
      case 'copy':
        return faCopy;
      default:
        return faComment;
    }
  };
  
  // Map category name to number
  const mapCategoryToNumber = (categoryName) => {
    switch(categoryName?.toLowerCase()) {
      case 'marketing':
        return 0;
      case 'utility':
        return 1;
      case 'authentication':
        return 2;
      default:
        return 1; // Default to Utility
    }
  };

  // Function to generate the proper template data structure
  const generateTemplateData = () => {
    // Create exactly the structure needed, following the example format
    const templateData = [];
    // 1. HEADER - only add if not NONE
    if (values.headerType !== 'NONE') {
      const headerComponent = {
        type: "HEADER",
        format: values.headerType.toUpperCase(),
      };

      if (values.headerType === 'TEXT') {
        headerComponent.text = values.headerText || '';
        if (values.headerExampleValues && Object.keys(values.headerExampleValues).length > 0) {
          headerComponent.example = {
            header_text: Object.values(values.headerExampleValues)
          };
        }
      } else if (values.headerType === 'IMAGE' || values.headerType === 'VIDEO' || values.headerType === 'DOCUMENT') {
        // Add example section only for file uploads (IMAGE, VIDEO, DOCUMENT) when we have token data
        if (values.headerMedia && values.headerMedia.uploadedData) {
          const tokenData = values.headerMedia.uploadedData.data;
          if (tokenData) {
            headerComponent.example = {
              header_handle: [tokenData]
            };
          }
        }
      }

      templateData.push(headerComponent);
    }
    
    // 2. BODY - required
    const bodyComponent = {
      type: "BODY"
    };


    if (values.templatecategory !== 2) {
      bodyComponent.text = values.bodymessage;
    } else {
      // Explicitly ensure no text field for authentication templates
      delete bodyComponent.text;
    }

    // For authentication templates, set example value for {{1}}
    if (values.templatecategory === 2) {
      bodyComponent.example = { body_text: [['123456']] };
    } else {
      const bodyVars = (values.bodymessage || '').match(/\{\{(\d+)\}\}/g) || [];
      if (bodyVars.length > 0) {
        const uniqueVarNums = [...new Set(bodyVars.map(v => parseInt(v.replace(/[{}]/g, ''))))].sort((a, b) => a - b);
        const sampleValues = uniqueVarNums.map(num => 
          (values.bodyExampleValues && values.bodyExampleValues[num] !== undefined && values.bodyExampleValues[num] !== '') 
            ? values.bodyExampleValues[num] 
            : `Value ${num}`
        );
        bodyComponent.example = {
          body_text: [sampleValues]
        };
      }
    }
    
    templateData.push(bodyComponent);
    
    // 3. FOOTER - optional
    if (values.footermessage && values.footermessage.trim() !== '') {
      templateData.push({
        type: "FOOTER",
        text: values.footermessage
      });
    }
    
    // 4. BUTTONS - optional - only add if there are actual buttons
    if (values.templatecategory === 2) {
      const buttonsComponent = {
        type: 'BUTTONS',
        buttons: [
          {
            type: 'URL',
            text: 'Copy code',
            url: 'https://www.whatsapp.com/otp/code/?otp_type=COPY_CODE&code=otp{{1}}',
            example: ['https://www.whatsapp.com/otp/code/?otp_type=COPY_CODE&code=otp123456']
          }
        ]
      };
      templateData.push(buttonsComponent);
    } else if (values.buttons && values.buttons.length > 0) {
      const buttonsComponent = {
        type: 'BUTTONS',
        buttons: values.buttons.map(btn => {
          let buttonType = btn.type || values.buttonType;
          if (buttonType === 'reply' || buttonType === 'quick_reply') {
            buttonType = 'QUICK_REPLY';
          }
          const buttonData = {
            type: buttonType,
            text: btn.text
          };
          if (buttonType === 'URL' || (values.buttonType === 'URL' && !btn.type)) {
            buttonData.url = btn.url || 'https://example.com';
            if (btn.example) buttonData.example = btn.example;
          } else if (buttonType === 'PHONE_NUMBER' || (values.buttonType === 'PHONE_NUMBER' && !btn.type)) {
            buttonData.phone_number = btn.phone_number || '+1234567890';
          }
          return buttonData;
        })
      };
      templateData.push(buttonsComponent);
    }
    
    return templateData;
  };
  
  // Function to format submission data - simplified
  const formatSubmissionData = () => {
    const templateData = generateTemplateData();    
    // Add check to ensure element exists
    const templateDataFormatEl = document.getElementById('templateDataFormat');
    if (templateDataFormatEl) {
      templateDataFormatEl.value = JSON.stringify(templateData);
    }
    
    return templateData;
  };

  // Add this helper function near the top, after imports or inside the component
  const mapCategory = (cat) => {
    switch (cat) {
      case 0:
        return "MARKETING";
      case 1:
        return "UTILITY";
      case 2:
        return "AUTHENTICATION";
      default:
        return "UTILITY"; // fallback
    }
  };

  // Effect to add/remove authentication code button as URL type
  useEffect(() => {
    if (values.templatecategory === 2) {
      if (codeDeliveryMethod === 'COPY_CODE') {
        // Add URL button for authentication if not present
        if (!values.buttons.some(btn => btn.type === 'URL')) {
          setFieldValue('buttons', [
            ...values.buttons.filter(btn => btn.type !== 'COPY_CODE'),
            {
              type: 'URL',
              text: 'Copy code',
              url: 'https://www.whatsapp.com/otp/code/?otp_type=COPY_CODE&code=otp{{1}}',
              example: ['https://www.whatsapp.com/otp/code/?otp_type=COPY_CODE&code=otp123456']
            }
          ]);
        }
      } else {
        // Remove URL button if present
        if (values.buttons.some(btn => btn.type === 'URL')) {
          setFieldValue('buttons', values.buttons.filter(btn => btn.type !== 'URL'));
        }
      }
    }
    // eslint-disable-next-line
  }, [codeDeliveryMethod, values.templatecategory]);

  // Check permissions for create/update access
  // const requiredPermission = isEditMode ? PERMISSIONS.TEMPLATES_UPDATE : PERMISSIONS.TEMPLATES_CREATE;
  
  // if (!hasPermission(requiredPermission)) {
  //   return (
  //     <div className="container-fluid">
  //       <div className="row justify-content-center">
  //         <div className="col-12 text-center mt-5">
  //           <h3>Access Denied</h3>
  //           <p>You don't have permission to {isEditMode ? 'edit' : 'create'} templates.</p>
  //           <button 
  //             className="btn btn-primary mt-3" 
  //             onClick={() => navigate('/client-area/manage-template')}
  //           >
  //             Back to Templates
  //           </button>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // }

  return (
    <div className='create-template-container' style={{maxWidth: '100vw', overflowX: 'hidden'}}>
      {loading && (
        <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="text-white text-2xl">Loading Template...</div>
        </div>
      )}
      <section className="row p-0 d-sm-flex justify-content-around" style={{maxWidth: '100%', margin: '0 auto'}}>
        <style jsx="true">{`
          .variable-highlight {
            color: #6366F1;
            font-weight: 500;
            background-color: rgba(99, 102, 241, 0.08);
            border-radius: 3px;
            padding: 0 4px;
          }
          .preview-header-text .variable-highlight {
            display: inline-block;
            margin: 0 2px;
          }
          .preview-body .text-primary {
            color: #6366F1 !important;
            font-weight: 500;
            background-color: rgba(99, 102, 241, 0.08);
            border-radius: 3px;
            padding: 0 4px;
          }
          .auth-template-section .badge-success {
            background-color: #28a745;
            color: white;
            font-weight: normal;
          }
          .copy-code-preview-button {
            display: inline-flex;
            align-items: center;
            background-color: #f8f9fa;
            color: #212529;
            border-color: #dee2e6;
            border-radius: 4px;
            font-weight: 500;
            box-shadow: 0 1px 2px rgba(0,0,0,0.05);
            cursor: pointer;
          }
          .copy-code-preview-button:hover {
            background-color: #e9ecef;
          }
          .auth-template-preview {
            background-color: #f8f9fa;
            border-color: #dee2e6;
          }
          .radio-container {
            position: relative;
            display: block;
            margin-bottom: 10px;
          }
          .custom-radio {
            position: absolute;
            opacity: 0;
            cursor: pointer;
          }
          .radio-label {
            cursor: pointer;
            padding-left: 30px;
            font-weight: 500;
            margin-bottom: 0;
          }
          .radio-checkmark {
            position: absolute;
            top: 0;
            left: 0;
            height: 20px;
            width: 20px;
            background-color: #fff;
            border: 1px solid #ced4da;
            border-radius: 50%;
          }
          .custom-radio:checked ~ .radio-checkmark {
            background-color: #0d6efd;
            border-color: #0d6efd;
          }
          .radio-checkmark:after {
            content: "";
            position: absolute;
            display: none;
          }
          .custom-radio:checked ~ .radio-checkmark:after {
            display: block;
            top: 6px;
            left: 6px;
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background: white;
          }
        `}</style>
        <form 
          key={templateId}
          style={{height: '100%',border: '1px solid red'}} 
          className='col-lg-8 col-md-8 col-12 p-0 bg-white pt-3 border border-1 mx-1 mb-3' 
          onSubmit={(e) => {
          // Prevent the default form submission
          e.preventDefault();
          // The actual submission will be handled by the button's onClick handler
        }}
        >
          <input type="hidden" id="templateDataFormat" name="templateDataFormat" value="" />
          
          <div className='row mx-2'>
            <div className='form-group m-0'>
              <label className="d-block bold mb-2">Template Category</label>
              <div className="d-flex flex-wrap">
                <button 
                  type="button" 
                  onClick={()=> CateGory(0)} 
                  className={`btn btn-lg btn-block rounded-0 col-lg-4 col-12 border m-0 ${values.templatecategory === 0 ? 'active-category' : ''} ${isEditMode ? 'disabled' : ''}`}
                  style={values.templatecategory === 0 ? {background: '#e8f5e8', borderColor: '#075E54', color: '#075E54'} : {}}
                  disabled={isEditMode}
                  title={isEditMode ? 'Template category cannot be changed in edit mode' : ''}
                > 
                  <FontAwesomeIcon icon={faBullhorn}></FontAwesomeIcon> Marketing
                </button>
                <button 
                  type="button" 
                  onClick={()=> CateGory(1)} 
                  className={`btn btn-lg btn-block rounded-0 col-lg-4 col-12 border m-0 ${values.templatecategory === 1 ? 'active-category' : ''} ${isEditMode ? 'disabled' : ''}`}
                  style={values.templatecategory === 1 ? {background: '#e8f5e8', borderColor: '#075E54', color: '#075E54'} : {}}
                  disabled={isEditMode}
                  title={isEditMode ? 'Template category cannot be changed in edit mode' : ''}
                >
                  <FontAwesomeIcon icon={faBell}></FontAwesomeIcon> Utility
                </button>
                <button 
                  type="button" 
                  onClick={()=> CateGory(2)} 
                  className={`btn btn-lg btn-block rounded-0 col-lg-4 col-12 border m-0 ${values.templatecategory === 2 ? 'active-category' : ''} ${isEditMode ? 'disabled' : ''}`}
                  style={values.templatecategory === 2 ? {background: '#e8f5e8', borderColor: '#075E54', color: '#075E54'} : {}}
                  disabled={isEditMode}
                  title={isEditMode ? 'Template category cannot be changed in edit mode' : ''}
                > 
                  <FontAwesomeIcon icon={faKey}></FontAwesomeIcon> Authentication
                </button>
              </div>
              {isEditMode && (
                <small className="text-muted mt-2 d-block">
                  <i className="typcn typcn-info-large mr-1"></i>
                  Template category cannot be changed in edit mode
                </small>
              )}
            </div>
          </div>
          {categoryerror ? <span className='text-danger ml-4' style={{fontSize: '13px'}}>{categoryerror}</span> : ''}
          
          <div className='row mx-2'>
            <div className='col-lg-12'>
              <Templatename 
                key={values.templatecategory}
                templatename={values.templatename} 
                handleChange={handleChange} 
                handleBlur={handleBlur} 
                templatenameerror={errors.templatename} 
                templatenametouched={touched.templatename} 
                templatelanguages={values.templatelanguages}
                templatelanguageserrors={errors.templatelanguages} 
                templatelanguagestouched={touched.templatelanguages}
                isEditMode={isEditMode}
              />
            </div>
            
          </div>

          {/* Only show header/body content if NOT Authentication template */}
          {values.templatecategory !== 2 && (
            <>
              <div className='row p-0 m-0 mx-sm-2 bg-white py-3 pt-1 d-flex'>   
                <div className='w-100 w-xl-50'>
                  <Templateheader 
                    key={values.templatecategory}
                    headerType={values.headerType}
                    headerText={values.headerText}
                    handleChange={(type) => setFieldValue("headerType", type)} 
                    onFileChange={handleHeaderFileChange}
                    onTextChange={handleHeaderTextChange}
                    variable={headerVariable} 
                    setvariable={setHeaderVariable}
                    exampleValues={values.headerExampleValues}
                    setExampleValues={(vars) => setFieldValue('headerExampleValues', vars)}
                  />
                  
                  {mediaError && (
                    <div className="col-12 mt-2">
                      <div className="alert alert-danger" role="alert">
                        <small>{mediaError}</small>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              
              <div className='row p-0 m-0 mx-sm-2 bg-white py-3 pt-1 d-flex'>   
                <div className='w-100 w-xl-50'>
                  <Templatebody 
                    bodymessage={values.bodymessage} 
                    setFieldValue={setFieldValue} 
                    handleChange={handleChange} 
                    bodymessageerror={errors.bodymessage} 
                    bodymessagetouched={touched.bodymessage} 
                    handleBlur={handleBlur} 
                    variable={bodyVariable} 
                    setvariable={setBodyVariable}
                    exampleValues={values.bodyExampleValues}
                    setExampleValues={(vars) => setFieldValue('bodyExampleValues', vars)}
                    advancedOptions={advancedOptions}
                  />
                  
                  {/* Sample Variable Values Section */}
                  {bodyVariable?.data?.length > 0 && (
                    <div className="variable-samples-container border rounded p-3 my-3">
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <h5 className="mb-0">Sample Variable Values</h5>
                        <span className="badge badge-primary">
                          {bodyVariable?.data?.length} variable{bodyVariable?.data?.length !== 1 ? 's' : ''}
                        </span>
                      </div>
                      <p className="text-muted small mb-3">
                        Add example values for each variable in your template. These will be used in the preview and help reviewers understand your template.
                      </p>
                      
                      <div className="row">
                        {bodyVariable?.data?.map(num => (
                          <div key={num} className="col-md-6 mb-3">
                            <div className="form-group">
                              <label className="font-weight-bold d-flex justify-content-between">
                                <span>Variable {`{{${num}}}`}</span>
                                <small className="text-muted">Sample Value</small>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter a sample value"
                                value={values.bodyExampleValues && values.bodyExampleValues[num] !== undefined ? values.bodyExampleValues[num] : ''}
                                onChange={(e) => {
                                  const newValues = { ...(values.bodyExampleValues || {}), [num]: e.target.value };
                                  setFieldValue('bodyExampleValues', newValues);
                                }}
                              />
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                  
                  <Templatefooter 
                    key={values.templatecategory}
                    footermessage={values.footermessage}
                    buttons={values.buttons}
                    setFieldValue={setFieldValue}
                    advancedOptions={advancedOptions}
                    buttonType={values.buttonType}
                    onButtonTypeChange={(type) => setFieldValue('buttonType', type)}
                    templateCategory={values.templatecategory}
                  />
                </div>
              </div>
            </>
          )}
          
          {/* Authentication Template - Code Delivery Setup */}
          {values.templatecategory === 2 && (
            <div className="auth-template-section mt-4 mb-4 border rounded p-3">
              <h5 className="mb-3">Code delivery setup</h5>
              <p className="text-muted small mb-4">
                Choose how customers send the code from WhatsApp to your app. 
                Edits to this section won't require review or count towards edit limits.
              </p>
              
              <div className="form-check mb-3">
                <input 
                  className="form-check-input" 
                  type="radio" 
                  name="codeDeliveryMethod" 
                  id="copyCodeMethod" 
                  checked={codeDeliveryMethod === 'COPY_CODE'}
                  onChange={() => setCodeDeliveryMethod('COPY_CODE')}
                />
                <label className="form-check-label d-flex align-items-center" htmlFor="copyCodeMethod">
                  <strong className="mr-2">Copy code</strong>
                  <span className="badge badge-success ml-2">Recommended</span>
                </label>
                <p className="text-muted small mt-2 mb-0 ml-4">
                  Basic authentication with quick setup. Your customers copy and paste the code into your app.
                </p>
              </div>
              <div className="form-check mb-3">
                <input 
                  className="form-check-input" 
                  type="radio" 
                  name="codeDeliveryMethod" 
                  id="noCodeButtonMethod" 
                  checked={codeDeliveryMethod === 'NONE'}
                  onChange={() => setCodeDeliveryMethod('NONE')}
                />
                <label className="form-check-label d-flex align-items-center" htmlFor="noCodeButtonMethod">
                  <strong className="mr-2">No code button</strong>
                </label>
                <p className="text-muted small mt-2 mb-0 ml-4">
                  No button will be shown for code delivery.
                </p>
              </div>
              
              <div className="auth-template-preview mt-4 p-3 border rounded bg-light">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <div>
                    <strong>Preview</strong>
                  </div>
                  <div className="text-muted small">
                    07:59
                  </div>
                </div>
                <p className="mb-3">
                  {values.bodyExampleValues && values.bodyExampleValues[1] ? values.bodyExampleValues[1] : '123456'} is your verification code. For your security, do not share this code.
                </p>
                <div className="d-flex">
                  <div className="copy-code-preview-button px-3 py-2 border rounded">
                    <FontAwesomeIcon icon={faCopy} className="mr-2" />
                    Copy code
                  </div>
                </div>
              </div>
            </div>
          )}
              
          <div className="row p-0 m-0 mx-sm-2">
            <div className="w-100 w-xl-50">
            <button 
              type="button" 
              className="btn btn-icon-text my-4 w-100" 
              style={PrimaryColor()}
              onClick={(e) => {
                // Validate the form data first
                if (values.templatecategory === 3) {
                  ErrorToastContainer("Please select a category");
                  return;
                }
                
                // Prevent editing authentication templates
                if (isEditMode && values.templatecategory === 2) {
                  ErrorToastContainer("Authentication templates cannot be edited. Please create a new template instead.");
                  return;
                }
                
                if (!values.templatename) {
                  ErrorToastContainer("Template name is required");
                  return;
                }
                
                if (!values.templatelanguages) {
                  ErrorToastContainer("Please select a language");
                  return;
                }
                
                if (!values.bodymessage && values.templatecategory !== 2) {
                  ErrorToastContainer("Body message is required");
                  return;
                }
                
                // Store reference to the button
                const submitButton = e.currentTarget;
                if (!submitButton) return;
                
                // Disable the button to prevent multiple submissions
                submitButton.disabled = true;
                submitButton.innerHTML = '<i class="typcn typcn-time"></i> Submitting...';
                
                // Format the data for submission
                try {
                  let templateData = formatSubmissionData();
                  // For authentication templates, ensure the text field is removed from the BODY component
                  if (values.templatecategory === 2 && templateData.length > 0) {
                    const bodyComponent = templateData.find(c => c.type === 'BODY');
                    if (bodyComponent && bodyComponent.text) {
                      delete bodyComponent.text;
                    }
                  }
                  // Prepare the request
                  const myHeaders = new Headers();
                  const access_token = getToken();
                  myHeaders.append("Authorization", `Bearer ${access_token}`);
                  myHeaders.append("Content-Type", "application/json");
                  let requestBody;
                  if (isEditMode) {
                    const decodedId = atob(templateId);
                    requestBody = {
                      components: templateData,
                      id: decodedId
                    };
                  } else {
                    // For create mode, send all fields
                    console.log("Submitting category value:", values.templatecategory, "Mapped:", mapCategory(values.templatecategory));
                    requestBody = {
                      name: values.templatename,
                      category: mapCategory(values.templatecategory),
                      language: values.templatelanguages,
                      components: templateData,
                    };
                  }
                  console.log("Request body for submission:", bodyVariable?.data?.length);
       
                  // Send the request to the appropriate endpoint
                  const endpoint = isEditMode ? `${domain()}/edit`: `${domain()}/create-template`;
                  fetch(endpoint, {
                    method: isEditMode ? "PUT" : "POST",
                    headers: myHeaders,
                    body: JSON.stringify(requestBody)
                  })
                    .then(response => response.json())
                    .then(result => {
                      // Reset button state
                      if (submitButton) {
                        submitButton.disabled = false;
                        submitButton.innerHTML = `<i class="typcn typcn-document btn-icon-prepend"></i> ${isEditMode ? 'Update' : 'Submit'} Template`;
                      }
                      
                      if (result.status) {
                        SuccessToastContainer(result.message);
                        // Redirect to manage templates page
                        setTimeout(() => {
                          navigate('/client-area/whatsapp/manage-template');
                        }, 1500);
                      } else {
                        ErrorToastContainer(result.message || "Failed to submit template");
                      }
                    })
                    .catch(error => {
                      console.error('Error:', error);
                      ErrorToastContainer("An error occurred while submitting the template");
                      
                      // Reset button state
                      if (submitButton) {
                        submitButton.disabled = false;
                        submitButton.innerHTML = `<i class="typcn typcn-document btn-icon-prepend"></i> ${isEditMode ? 'Update' : 'Submit'} Template`;
                      }
                    });
                  
                } catch (error) {
                  // Handle error and reset button state
                  console.error("Error preparing template data:", error);
                  ErrorToastContainer("An error occurred while preparing the template data. Please try again.");
                  
                  // No need to clear timeout as it's not set anymore
                  // clearTimeout(resetTimeout);
                  
                  if (submitButton) {
                    submitButton.disabled = false;
                    submitButton.innerHTML = '<i class="typcn typcn-document btn-icon-prepend"></i> Submit Template';
                  }
                }
              }}
            >
              <i className="typcn typcn-document btn-icon-prepend"></i>
              {isEditMode ? 'Update Template' : 'Submit Template'}
                </button>
              
              {/* Debug button to check data format */}
              <button 
                type="button"
                className="btn btn-sm btn-outline-secondary mb-2 w-100"
                onClick={() => {
                  // Use the same formatting function as the submit button
                  const templateData = formatSubmissionData();
                  let debugData;
                  
                  if (isEditMode) {
                    // For edit mode, show components and id
                    debugData = {
                      components: templateData,
                      id: templateId
                    };
                  } else {
                    // For create mode, show all fields
                    debugData = {
                      name: values.templatename,
                      category: mapCategory(values.templatecategory),
                      language: values.templatelanguages,
                      components: templateData,
                    };
                  }
                  
                  const formatted = JSON.stringify(debugData, null, 2);
                  console.log('TEMPLATE DATA FORMAT:', formatted);
                }}
              >
                <i className="typcn typcn-info-large"></i> Check Template Format
              </button>
            </div>
          </div>
        </form>
        
        <div className='col-lg-3 col-md-8 col-sm-8 col-12 p-0 m-0'>
          <div className='bg-white border border-1 rounded mb-3 p-3'>
            <div className='d-flex justify-content-between align-items-center mb-3'>
              <p className='font-weight-bold m-0'>Template Preview</p>
            </div>
            <div className={`preview-container desktop-view`}>
              <div className="wa-preview-header">
                <div className="wa-preview-header-content">
                  <span>WhatsApp Business</span>
                  <span className="wa-preview-time">{currentTime}</span>
                </div>
              </div>
              
              <div className="preview-chat-container" style={{ backgroundImage: `url(${ChatBoat})`,height: '1000px' }}>
                <div className="preview-message-container">
                  <div className="preview-message bg-white rounded-0 shadow-sm">
                    {/* Header Preview */}
                    {values.headerType !== 'NONE' && (
                      <div className="preview-header">
                        {values.headerType === 'TEXT' && values.headerText && (
                          <div 
                            className="preview-header-text text-center p-2 border-bottom"
                            dangerouslySetInnerHTML={{ __html: renderHeaderPreview() }}
                          >
                          </div>
                        )}
                        
                        {values.headerType === 'IMAGE' && (
                          <div className="preview-header-media">
                            <img 
                              src={
                                isEditMode
                                  ? values.headerMedia?.url
                                  : (headerPreviewUrl || (values.headerMedia?.file ? URL.createObjectURL(values.headerMedia.file) : undefined))
                              }
                              alt="Header media"
                              className="preview-media"
                              style={{ maxWidth: '100%', maxHeight: 200 }}
                            />
                          </div>
                        )}
                        
                        {values.headerType === 'IMAGE' && !values.headerMedia && (
                          <div className="preview-header-media bg-light text-center p-3">
                            <span>Header image</span>
                          </div>
                        )}
                        
                        {values.headerType === 'VIDEO' && (
                          <div className="preview-header-media">
                            <div className="video-placeholder d-flex align-items-center justify-content-center">
                              <div className="text-center">
                                <FontAwesomeIcon icon={faEye} className="mb-2" size="2x" />
                                <div>Video Preview</div>
                                {values.headerMedia && (
                                  <small className="d-block mt-1">{values.headerMedia?.file?.name || ''}</small>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        
                        {values.headerType === 'DOCUMENT' && (
                          <div className="preview-header-document d-flex align-items-center p-2 border-bottom">
                            <div className="document-icon mr-2">
                              <FontAwesomeIcon icon={faCode} />
                            </div>
                            <div className="document-info">
                              <div className="document-name">
                                {values.headerMedia?.file?.name || 'Document'}
                              </div>
                              <div className="document-size text-muted small">
                                {values.headerMedia ? 
                                  `PDF · ${(values.headerMedia.file.size / 1024).toFixed(1)}KB` : 
                                  'PDF'}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                    
                    {/* Body Preview */}
                    {values.bodymessage || values.templatecategory === 2 ? (
                      <div className={`preview-body p-3${values.templatecategory === 2 ? ' bg-light' : ''}`}
                        dangerouslySetInnerHTML={{ __html: (values.templatecategory === 2 && !values.bodymessage)
                          ? '{{1}} is your verification code. For your security, do not share this code.'.replace('{{1}}', '<span class="text-primary">123456</span>')
                          : renderPreview() }}>
                      </div>
                    ) : null}
                    
                    {/* Footer Preview */}
                    {values.footermessage && (
                    <div className="preview-footer-text text-muted smal text-start pl-2 pb-1">
                      {values.footermessage}
                    </div>
                  )}
                  {/* Buttons Preview */}
                  {values.buttons && values.buttons.length > 0 && (
                    <div>
                      {values.buttons.map((button, idx) => (
                        <button key={idx} className="btn-wa-preview w-100">
                          <FontAwesomeIcon icon={getButtonIcon(button.type || values.buttonType)} className="mr-2" />
                          {button.text}
                          {button.type === 'copy' && (
                            <span className="copy-code-preview">
                              <FontAwesomeIcon icon={faCopy} className="ml-2" />
                            </span>
                          )}
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              </div>
              </div>
            
              <div className="wa-preview-footer">
                <div className="wa-input-container">
                  <input type="text" readOnly className="wa-input" placeholder="Type a message" />
                </div>
              </div>
          </div>
          
          {/* Technical preview toggle button */}
          {advancedOptions && (
            <button 
              type="button" 
              className="btn btn-sm btn-outline-secondary w-100 mt-3"
              onClick={toggleTechnicalPreview}
            >
              <FontAwesomeIcon icon={faCode} className="mr-2" />
              {technicalPreview ? 'Hide' : 'Show'} Technical Preview
            </button>
          )}
        </div>
        
        {/* Technical Preview section */}
        {advancedOptions && technicalPreview && (
          <div className='bg-white border border-1 rounded p-3'>
            <h6>Technical Preview</h6>
            <p className="text-muted small">Template structure for developers</p>
            
            <div className="template-structure-preview border p-2 rounded bg-light">
              <pre className="m-0" style={{fontSize: '12px', whiteSpace: 'pre-wrap'}}>
                {JSON.stringify(generateTemplateData(), null, 2)}
              </pre>
            </div>
          </div>
        )}
        </div>
    </section>
  </div>
  )
}

export default Createtemplate;


